/* Project-level metadata shown in the sidebar and the mobile drawer. */
export const META = [
  { label: 'ROLES',    values: ['UI Designer', 'UX Researcher', 'Information Architect'] },
  { label: 'TIMELINE', values: ['8 Weeks'] },
  { label: 'TEAM',     values: ['2 Designers'] },
  { label: 'TOOLS',    values: ['Figma', 'Zoom', 'Google Workspace'] },
];

/* Page-level navigation, also shared between sidebar and drawer. */
export const NAV = [
  { num: '01', label: 'HOME',    href: '/home' },
  { num: '02', label: 'ABOUT',   href: '/about' },
  { num: '03', label: 'CONTACT', href: '/contact' },
];

/* Canonical project order — drives the homepage cards, case-study prev/next,
   and the "Work" nav dropdown. */
export const PROJECTS = [
  { label: 'Solace',             href: '/solace-v2' },
  { label: 'Atlas',              href: '/atlas'     },
  { label: 'pAIwares',           href: '/paiwares'  },
  { label: 'The Santos Podcast', href: '/santos'    },
];
